import { render, staticRenderFns } from "./rentRate.vue?vue&type=template&id=1244cf2a&scoped=true"
import script from "./rentRate.vue?vue&type=script&lang=js"
export * from "./rentRate.vue?vue&type=script&lang=js"
import style0 from "./rentRate.vue?vue&type=style&index=0&id=1244cf2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244cf2a",
  null
  
)

export default component.exports